/**
 * Authentication store using Zustand
 */

import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface Operator {
  id: number
  username: string
  email?: string
  full_name?: string
  role: string
  is_active: boolean
  is_online?: boolean
}

interface AuthState {
  accessToken: string | null
  refreshToken: string | null
  operator: Operator | null
  isAuthenticated: boolean
  
  setAuth: (accessToken: string, refreshToken: string, operator: Operator) => void
  updateTokens: (accessToken: string, refreshToken: string) => void
  clearAuth: () => void
  updateOperator: (operator: Partial<Operator>) => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      operator: null,
      isAuthenticated: false,
      
      setAuth: (accessToken, refreshToken, operator) => {
        set({
          accessToken,
          refreshToken,
          operator,
          isAuthenticated: true,
        })
      },
      
      updateTokens: (accessToken, refreshToken) => {
        set({
          accessToken,
          refreshToken,
        })
      },
      
      clearAuth: () => {
        set({
          accessToken: null,
          refreshToken: null,
          operator: null,
          isAuthenticated: false,
        })
      },
      
      updateOperator: (updates) => {
        set((state) => ({
          operator: state.operator ? { ...state.operator, ...updates } : null,
        }))
      },
    }),
    {
      name: 'afi-auth-storage',
      // * Handle deserialization errors gracefully
      onRehydrateStorage: () => (_state, error) => {
        if (error) {
          console.error('Failed to rehydrate auth store:', error)
          // ! Clear corrupted storage
          localStorage.removeItem('afi-auth-storage')
        }
      },
    }
  )
)

